import {
  captureStack1fzi4aczwc4hg as captureStack,
  createExternalThis2k2orr8ix0ytc as createExternalThis,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  setupCauseParameter20kc7dphipdif as setupCauseParameter,
  toString1pkumu07cwy4m as toString,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from './Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_UnsupportedOperationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.z_1);
}
var UnsupportedOperationExceptionClass;
function UnsupportedOperationException() {
  if (UnsupportedOperationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static j8() {
        var $this = this.d4();
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
      static a1(message) {
        var $this = this.ra(message);
        init_kotlin_UnsupportedOperationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsupportedOperationException', $.j8);
    UnsupportedOperationExceptionClass = $;
  }
  return UnsupportedOperationExceptionClass;
}
function init_kotlin_IllegalStateException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.l_1);
}
var IllegalStateExceptionClass;
function IllegalStateException() {
  if (IllegalStateExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static m() {
        var $this = this.d4();
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static o(message) {
        var $this = this.ra(message);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
      static q(message, cause) {
        var $this = this.qd(message, cause);
        init_kotlin_IllegalStateException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalStateException', $.m);
    IllegalStateExceptionClass = $;
  }
  return IllegalStateExceptionClass;
}
function init_kotlin_IllegalArgumentException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.m2_1);
}
var IllegalArgumentExceptionClass;
function IllegalArgumentException() {
  if (IllegalArgumentExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static rd() {
        var $this = this.d4();
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static n2(message) {
        var $this = this.ra(message);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static sd(message, cause) {
        var $this = this.qd(message, cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
      static td(cause) {
        var $this = this.ud(cause);
        init_kotlin_IllegalArgumentException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalArgumentException', $.rd);
    IllegalArgumentExceptionClass = $;
  }
  return IllegalArgumentExceptionClass;
}
function init_kotlin_RuntimeException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.c4_1);
}
var RuntimeExceptionClass;
function RuntimeException() {
  if (RuntimeExceptionClass === VOID) {
    class $ extends Exception() {
      static d4() {
        var $this = this.wd();
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static ra(message) {
        var $this = this.xd(message);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static qd(message, cause) {
        var $this = this.yd(message, cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
      static ud(cause) {
        var $this = this.zd(cause);
        init_kotlin_RuntimeException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'RuntimeException', $.d4);
    RuntimeExceptionClass = $;
  }
  return RuntimeExceptionClass;
}
function init_kotlin_Exception(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.vd_1);
}
var ExceptionClass;
function Exception() {
  if (ExceptionClass === VOID) {
    class $ extends Error {
      static wd() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Exception($this);
        return $this;
      }
      static xd(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Exception($this);
        return $this;
      }
      static yd(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Exception($this);
        return $this;
      }
      static zd(cause) {
        var $this = createExternalThis(this, Error, [null, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, VOID, cause);
        init_kotlin_Exception($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Exception', $.wd);
    ExceptionClass = $;
  }
  return ExceptionClass;
}
function init_kotlin_NoSuchElementException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.z1_1);
}
var NoSuchElementExceptionClass;
function NoSuchElementException() {
  if (NoSuchElementExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static t6() {
        var $this = this.d4();
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
      static a2(message) {
        var $this = this.ra(message);
        init_kotlin_NoSuchElementException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoSuchElementException', $.t6);
    NoSuchElementExceptionClass = $;
  }
  return NoSuchElementExceptionClass;
}
function init_kotlin_IndexOutOfBoundsException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h3_1);
}
var IndexOutOfBoundsExceptionClass;
function IndexOutOfBoundsException() {
  if (IndexOutOfBoundsExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static ae() {
        var $this = this.d4();
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
      static i3(message) {
        var $this = this.ra(message);
        init_kotlin_IndexOutOfBoundsException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IndexOutOfBoundsException', $.ae);
    IndexOutOfBoundsExceptionClass = $;
  }
  return IndexOutOfBoundsExceptionClass;
}
function init_kotlin_NullPointerException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.r5_1);
}
var NullPointerExceptionClass;
function NullPointerException() {
  if (NullPointerExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static s5() {
        var $this = this.d4();
        init_kotlin_NullPointerException($this);
        return $this;
      }
      static be(message) {
        var $this = this.ra(message);
        init_kotlin_NullPointerException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NullPointerException', $.s5);
    NullPointerExceptionClass = $;
  }
  return NullPointerExceptionClass;
}
function init_kotlin_ArithmeticException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.ee_1);
}
var ArithmeticExceptionClass;
function ArithmeticException() {
  if (ArithmeticExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static fe() {
        var $this = this.d4();
        init_kotlin_ArithmeticException($this);
        return $this;
      }
      static ge(message) {
        var $this = this.ra(message);
        init_kotlin_ArithmeticException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ArithmeticException', $.fe);
    ArithmeticExceptionClass = $;
  }
  return ArithmeticExceptionClass;
}
function init_kotlin_Error(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.he_1);
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ extends Error {
      static ie() {
        var $this = createExternalThis(this, Error, [null]);
        setPropertiesToThrowableInstance($this);
        init_kotlin_Error($this);
        return $this;
      }
      static je(message) {
        var $this = createExternalThis(this, Error, [message]);
        setPropertiesToThrowableInstance($this, message);
        init_kotlin_Error($this);
        return $this;
      }
      static ke(message, cause) {
        var $this = createExternalThis(this, Error, [message, setupCauseParameter(cause)]);
        setPropertiesToThrowableInstance($this, message, cause);
        init_kotlin_Error($this);
        return $this;
      }
    }
    initMetadataForClass($, 'Error', $.ie);
    ErrorClass = $;
  }
  return ErrorClass;
}
function init_kotlin_NumberFormatException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.oe_1);
}
var NumberFormatExceptionClass;
function NumberFormatException() {
  if (NumberFormatExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static pe() {
        var $this = this.rd();
        init_kotlin_NumberFormatException($this);
        return $this;
      }
      static qe(message) {
        var $this = this.n2(message);
        init_kotlin_NumberFormatException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NumberFormatException', $.pe);
    NumberFormatExceptionClass = $;
  }
  return NumberFormatExceptionClass;
}
function init_kotlin_AssertionError(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.se_1);
}
var AssertionErrorClass;
function AssertionError() {
  if (AssertionErrorClass === VOID) {
    class $ extends Error_0() {
      static te() {
        var $this = this.ie();
        init_kotlin_AssertionError($this);
        return $this;
      }
      static ue(message) {
        var $this = this.je(message);
        init_kotlin_AssertionError($this);
        return $this;
      }
      static ve(message) {
        var tmp = message == null ? null : toString(message);
        var $this = this.ke(tmp, message instanceof Error ? message : null);
        init_kotlin_AssertionError($this);
        return $this;
      }
    }
    initMetadataForClass($, 'AssertionError', $.te);
    AssertionErrorClass = $;
  }
  return AssertionErrorClass;
}
function init_kotlin_UninitializedPropertyAccessException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.v_1);
}
var UninitializedPropertyAccessExceptionClass;
function UninitializedPropertyAccessException() {
  if (UninitializedPropertyAccessExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static we() {
        var $this = this.d4();
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
      static w(message) {
        var $this = this.ra(message);
        init_kotlin_UninitializedPropertyAccessException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'UninitializedPropertyAccessException', $.we);
    UninitializedPropertyAccessExceptionClass = $;
  }
  return UninitializedPropertyAccessExceptionClass;
}
function init_kotlin_ConcurrentModificationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.ma_1);
}
var ConcurrentModificationExceptionClass;
function ConcurrentModificationException() {
  if (ConcurrentModificationExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static db() {
        var $this = this.d4();
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
      static na(message) {
        var $this = this.ra(message);
        init_kotlin_ConcurrentModificationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ConcurrentModificationException', $.db);
    ConcurrentModificationExceptionClass = $;
  }
  return ConcurrentModificationExceptionClass;
}
function init_kotlin_NoWhenBranchMatchedException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.n5_1);
}
var NoWhenBranchMatchedExceptionClass;
function NoWhenBranchMatchedException() {
  if (NoWhenBranchMatchedExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static o5() {
        var $this = this.d4();
        init_kotlin_NoWhenBranchMatchedException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'NoWhenBranchMatchedException', $.o5);
    NoWhenBranchMatchedExceptionClass = $;
  }
  return NoWhenBranchMatchedExceptionClass;
}
function init_kotlin_ClassCastException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.v5_1);
}
var ClassCastExceptionClass;
function ClassCastException() {
  if (ClassCastExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static w5() {
        var $this = this.d4();
        init_kotlin_ClassCastException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'ClassCastException', $.w5);
    ClassCastExceptionClass = $;
  }
  return ClassCastExceptionClass;
}
//region block: exports
export {
  ArithmeticException as ArithmeticException18dajwq7kbp38,
  AssertionError as AssertionError3yq7q0knw9m5,
  ClassCastException as ClassCastException1atiay3nqgbd,
  ConcurrentModificationException as ConcurrentModificationException3974vl9oonkcj,
  Error_0 as Error3ofk6owajcepa,
  Exception as Exceptiondt2hlxn7j7vw,
  IllegalArgumentException as IllegalArgumentException2asla15b5jaob,
  IllegalStateException as IllegalStateExceptionkoljg5n0nrlr,
  IndexOutOfBoundsException as IndexOutOfBoundsException1qfr429iumro0,
  NoSuchElementException as NoSuchElementException679xzhnp5bpj,
  NoWhenBranchMatchedException as NoWhenBranchMatchedException3krrgsc7u48pz,
  NullPointerException as NullPointerException3mu0rhxjjitqq,
  NumberFormatException as NumberFormatException3bgsm2s9o4t55,
  RuntimeException as RuntimeException1r3t0zl97011n,
  UninitializedPropertyAccessException as UninitializedPropertyAccessException8qin22n38p0w,
  UnsupportedOperationException as UnsupportedOperationException2tkumpmhredt3,
};
//endregion

//# sourceMappingURL=exceptions.mjs.map
